import { useSizeContext } from '../../../contexts/SizeContextProvider';
import DesktopNav from './DesktopNav/DesktopNav';
import MobileNav from './MobileNav/MobileNav';
import './Sidebar.scss';

const Sidebar = () => {
    const { isMobile, isDesktop } = useSizeContext();
    return (
        <>
            <div className="col-md-4 col-lg-3">
                <div className="sidebar-wrapper p-3">
                    {isMobile && <MobileNav />}
                    {isDesktop && <DesktopNav />}
                </div>
            </div>
        </>
    );
};

export default Sidebar;
